export default __webpack_public_path__ + "static/media/convert-reward-to-ecredit-step2.e49f9f71.png";